module.exports = __webpack_public_path__ + "static/media/IRANSansWeb.cdf8f7e0.woff2";